<app-card-inner [loading]="loading$" [noDataFound]="patientConsultations.length === 0" [noDataMessage]="'NoNotesForPatient' | localizeText">
  <div header class="flex flex-row justify-between items-center">
    <div class="card-inner-title">
      <app-icon [icon]="icons.notebookOutline" class="mr-1"></app-icon>
      <span>{{ 'Notes' | localizeText : 'Notes' }}</span>
    </div>

    <app-circle-button class="text-blue" [icon]="icons.add" (click)="openPatientConsultModal()"></app-circle-button>
  </div>

  <div body class="flex flex-col p-1 w-full overflow-y-auto max-h-full space-y-1">
    @for (consultation of patientConsultations; track consultation) {
      <app-small-list-item
        [isClickable]="true"
        dateFormat="mediumDate"
        [date]="consultation.patientConsultation.creationTime"
        [text]="consultation.patientConsultation.notes"
        (clicked)="openPatientConsultModal(consultation.patientConsultation)"
      ></app-small-list-item>
    }
  </div>
</app-card-inner>
